// extracted by mini-css-extract-plugin
module.exports = {"form":"search-module--form--2YnOR","input":"search-module--input--3et7s","submit":"search-module--submit--3ZAR6","autocompleteList":"search-module--autocompleteList--3vCfg"};